import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Heading from '../components/heading/heading';
import axios from '../backendService';
import { Button, Card, Col, DatePicker, Form, Input, Modal, Space, Table, TimePicker, Tooltip, message } from 'antd';
import { IoMdArrowRoundBack } from 'react-icons/io';
import moment from 'moment';
import { PaginationStyle } from '../container/styled';

const VideoQuestions = () => {
  const { videoId } = useParams();
  const [videoObj, setVideoObj] = useState({});
  const [currentVideoQuestions, setCurrentVideoQuestions] = useState([]);
  const [currAnswer, setCurrAnswer] = useState(null);
  const [currQuestion, setCurrQuestion] = useState(null);
  const [currQuestionId, setCurrQuestionId] = useState(null);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const onCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  const handleModalOpen = (questionText, questionId, answer) => {
    setCurrQuestionId(questionId);
    form.setFieldValue('question', questionText);
    form.setFieldValue('answer', answer);
    setOpen(true);
  };

  let dataSource = [];

  // Fetch video data when page loads
  const fetchData = async () => {
    try {
      const response = await axios.get(`/videos/${videoId}`);
      const videoData = response.data;
      setVideoObj(videoData.video);
      setCurrentVideoQuestions(videoData.video.videoQuestions);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Fetch data on page loads
  useEffect(() => {
    fetchData();
  }, []);

  // Submit answer
  const handleAction = async (values) => {
    const postData = {
      questionId: currQuestionId,
      answer: values.answer,
    };
    // console.log(postData);
    try {
      const response = await axios.post('video-questions/answer-question', postData);
      // console.log(response.data);
      message.success(`Answer submitted`);
      form.resetFields();
      setCurrAnswer(null);
      setCurrQuestion(null);
      setCurrQuestionId(null);
      setOpen(false);
      fetchData();
    } catch (error) {
      console.error('Error submitting answer:', error);
    }
  };

  // Columns schema
  const columns = [
    {
      title: 'Sr.No.',
      dataIndex: 'srNo',
      key: 'srNo',
      width: '90px',
      className:
        'ltr:rounded-l-[10px] rtl:rounded-r-[10px] ltr:pl-[25px] rtl:pr-[25px] text-dark dark:text-white87 font-medium text-[15px] py-[16px] last:text-end border-none capitalize before:hidden',
    },
    {
      title: 'Student Name',
      dataIndex: 'studentName',
      key: 'studentName',
      align: 'center',
      width: 100,
      className:
        'ltr:pr-4 rtl:pl-4 text-dark dark:text-white87 font-medium text-[15px] py-[16px] last:text-end border-none capitalize before:hidden',
    },
    {
      title: 'Question',
      dataIndex: 'question',
      key: 'question',
      className: 'w-max min-h-[30px] border-none ',
    },
    {
      title: 'Answer',
      dataIndex: 'answer',
      key: 'answer',
      align: 'center',
      className: 'w-max min-h-[30px] border-none ',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      className: 'text-dark dark:text-white87 font-medium text-[15px] py-[16px] border-none capitalize before:hidden',
    },
  ];

  if (currentVideoQuestions.length) {
    currentVideoQuestions.map((que, index) => {
      const { _id, answer, question, lecture, student, teacher } = que;
      return dataSource.push({
        key: `${_id}`,
        srNo: `${index + 1}`,
        studentName: (
          <span className="text-[15px] text-theme-gray dark:text-white60 font-medium">
            {student && student.userName ? student.userName : 'NA'}
          </span>
        ),
        question: (
          <div className="flex items-center justify-start w-full min-h-20">
            <textarea
              className="flex items-center justify-center w-full min-h-[100px] border-none p-2"
              disabled
              value={question}
            />
          </div>
        ),
        answer: (
          <div className="flex items-center justify-start w-full min-h-20">
            <textarea
              className="flex items-center justify-center w-full min-h-[100px] border-none p-2"
              disabled
              value={answer}
            />
          </div>
        ),
        action: (
          <Button onClick={() => handleModalOpen(question, _id, answer)} type={'primary'} size={'small'}>
            Submit answer
          </Button>
        ),
      });
    });
  }

  return (
    <>
      <div className="min-w-screen min-h-screen bg-white">
        <div className="pt-5 w-full flex items-center justify-start">
          <Button
            type="primary"
            icon={<IoMdArrowRoundBack />}
            size={'large'}
            className="text-sm text-blue-700 gap-2 flex items-center justify-start"
            onClick={goBack}
          >
            Get back
          </Button>
        </div>
        <Heading as="h4" className="text-dark dark:text-white87 text-[22px] font-semibold pt-5">
          {videoObj.title}
          <br />
          {/* <span className="text-xs" style={{ color: '#bbb' }}>
            Id: {videoId}
          </span> */}
        </Heading>

        {/* Video Data */}
        <Space size={'large'} className="mt-5" wrap>
          <p>Course: {videoObj && videoObj.course && videoObj.course.courseName}</p>
          <p>Subject: {videoObj && videoObj.subject && videoObj.subject.subjectName}</p>
          <p>Chapter: {videoObj && videoObj.chapter && videoObj.chapter.chapterName}</p>
          <p>Topic: {videoObj && videoObj.topic && videoObj.topic.topicName}</p>
        </Space>
        <Space size={'large'} wrap>
          <p>Scheduled Date: {videoObj && videoObj.publishDate && videoObj.publishDate}</p>
          <p>Start Time: {videoObj && videoObj.startTime && videoObj.startTime}</p>
          <p>End Time: {videoObj && videoObj.endTime && videoObj.endTime}</p>
        </Space>

        <div className="mt-5 mb-10 mr-4">
          <PaginationStyle>
            <div className="table-pl-0 hover-tr-none table-pt-15 table-responsive ant-pagination-custom-style [&>div>div>div>ul]:pt-[30px] [&>div>div>div>ul]:mt-[20px] [&>div>div>div>ul]:border-normal dark:[&>div>div>div>ul]:border-white10 [&>div>div>div>ul]:border-t-1 [&>div>div>div>ul]:justify-center">
              <Table pagination={{ pageSize: 10, showSizeChanger: false }} dataSource={dataSource} columns={columns} />
            </div>
          </PaginationStyle>
        </div>
      </div>
      <Modal
        open={open}
        title="Submit your answer"
        okText="Submit"
        cancelText="Cancel"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              handleAction(values);
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form form={form} layout="vertical" name="form_in_modal">
          <Form.Item rules={[{ required: true }]} name="question">
            <Input disabled />
          </Form.Item>
          <Form.Item rules={[{ required: true }]} name="answer">
            <Input.TextArea rows={4} cols={4} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default VideoQuestions;
